import "whatwg-fetch";

import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { LoggerService as lgg } from "vue-components-library";
import Multiselect from "vue-multiselect";
import VueFormGenerator from "vue-form-generator";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import "vue-form-generator/dist/vfg.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

import "./App/assets/css/upload-loader.css";

import { name as projectName, version } from "../package.json";
import store from "@/App/store";
import router from "@/App/router";
import App from "@/App/ui/App.vue";
import "@/App/services/RegisterServiceWorker";
import VueRouter from "vue-router";
import UsernameField from "@/App/components/UsernameField.vue";
import { validateUsername } from "@/Users/functions/usernameValidator";

lgg.init({
  datadog: {
    clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN
  },
  env: process.env.VUE_APP_TARGET_ENVIRONMENT,
  project: projectName,
  version: version
});

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);

Vue.component("FieldCustomUsername", UsernameField);
Vue.use(VueFormGenerator, {
  validators: {
    isValidUsername: (value, field, model) => {
      return validateUsername(value, field.label, model);
    }
  }
});
// eslint-disable-next-line vue/component-definition-name-casing
Vue.component("multiselect", Multiselect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
